import AngularApp from "@/lib/angular/AngularApp";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/ntimev1/$")({
    component: RouteComponent,
});

function RouteComponent() {
    return <AngularApp />;
}
